// extracted by mini-css-extract-plugin
export default {"logotype":"logotype__35BuX"};